(ns shared.core.components.radio
  (:require [shared.core.components.icon :as icon]
            [shared.core.style :as style]
            [shared.core.reactive :as re]
            [shared.core.components.theme :as theme]))

(defn radio [{:keys [id form-path form-name val-subscribe disabled? selected? on-click container-style style
                     content-style support-deselect? disabled-style dark-radio-style dark-icon-style]}
             & contents]
  (let [selected?- (when val-subscribe (re/subscribe val-subscribe))
        radio-click (when-not disabled?
                      (or on-click
                          (when (and form-path form-name)
                            #(re/dispatch [:form/change form-path form-name (not @selected?-)]))))
        radio-style (merge {:color (style/color :green :base)
                            :font-size 22
                            :cursor :pointer
                            :flex (str "0 0 " (or (:font-size style) 22) "px")
                            :position :relative}
                           (when (and selected? (not support-deselect?))
                             {:cursor :default})
                           (when disabled?
                             {:cursor :not-allowed
                              :opacity 0.5})
                           (when disabled?
                             disabled-style)
                           style)]
    [:div {:id id
           :style (merge {:display :flex
                          :align-items :center}
                         container-style)}
     [:input {:type :checkbox
              :style {:opacity 0
                      :margin 0
                      :height 0
                      :width 0}}]
     [theme/theme
      :div {:style (assoc radio-style :height (:font-size radio-style))
            :theme (style/dark-style (merge {:color (style/dark-color :primary :base)}
                                            dark-radio-style))
            :on-click radio-click}
      [:div {:style {:background-color (style/color :white :base)
                     :border-radius "50%"
                     :position :absolute
                     :top 3
                     :left 3
                     :height "calc(100% - 6px)"
                     :width "calc(100% - 6px)"}}]
      [theme/theme
       icon/material-icon {:icon-type (if (or selected? (and selected?- @selected?-))
                                        :radio_button_checked
                                        :radio_button_unchecked)
                           :style {:color (:color radio-style)
                                   :font-size (:font-size radio-style)
                                   :position :relative
                                   :z-index (style/z :low)}
                           :theme (style/dark-style (merge {:color (style/dark-color :primary :base)}
                                                           dark-icon-style))}]]
     (when contents
       (into [:div {:style (merge {:color (style/colors :gray :base)
                                   :font-size 16
                                   :line-height 1.3
                                   :cursor :pointer
                                   :margin-left 5}
                                  (when (and selected? (not support-deselect?))
                                    {:cursor :default})
                                  (when disabled?
                                    {:cursor :not-allowed
                                     :opacity 0.5})
                                  content-style)
                    :on-click radio-click}]
             contents))]))

(defn small-radio [{:keys [style] :as args}
                   & contents]
  (into [radio (merge args
                      {:style (merge {:font-size 18
                                      :flex "0 0 18px"}
                                     style)})]
        contents))

(defn pill-radio [{:keys [id form-path form-name val-subscribe disabled? selected? on-click container-style
                          content-style support-deselect? first? last? selected-pill-style border-radius]
                   :or {border-radius 50}}
                  & contents]
  (let [selected?- (when val-subscribe (re/subscribe val-subscribe))
        radio-click (when-not disabled?
                      (or on-click
                          (when (and form-path form-name)
                            #(re/dispatch [:form/change form-path form-name (not @selected?-)]))))]
    [:div {:id id
           :style (merge {:background-color (style/color :gray :shade-22)
                          :width "100%"}
                         (when first?
                           {:border-top-left-radius border-radius
                            :border-bottom-left-radius border-radius})
                         (when last?
                           {:border-top-right-radius border-radius
                            :border-bottom-right-radius border-radius})
                         container-style)}
     (when contents
       (into [:div {:style (merge {:color (if selected?
                                            (style/color :white :base)
                                            (style/color :black :base))
                                   :background-color (if selected?
                                                       (style/color :gray :base)
                                                       (style/color :gray :shade-22))
                                   :font-size 14
                                   :font-weight style/font-semi-bold-weight
                                   :line-height 1.43
                                   :text-align :center
                                   :cursor :pointer
                                   :padding "6px 12px"}
                                  (when (and selected? (not support-deselect?))
                                    {:cursor :default})
                                  (when disabled?
                                    {:cursor :not-allowed
                                     :opacity 0.5})
                                  (when (or first? selected?)
                                    {:border-top-left-radius border-radius
                                     :border-bottom-left-radius border-radius})
                                  (when (or last? selected?)
                                    {:border-top-right-radius border-radius
                                     :border-bottom-right-radius border-radius})
                                  content-style
                                  (when (and selected? selected-pill-style)
                                    selected-pill-style))
                    :on-click radio-click}]
             contents))]))
